import React from "react";
import * as ListingPropertyType1 from "../../../../../../domain/models/ListingPropertyType1";
import * as ListingFloorAreaUnits1 from "../../../../../../domain/models/ListingFloorAreaUnits1";
import { ListingFactPanel, TListingFact } from "../ListingFactPanel/ListingFactPanel";

export type TListingKeyFactsProps = {
    propertyType: ListingPropertyType1.T;
    bedroomCount: number | null;
    bathroomCount: number | null;
    receptionRoomCount: number | null;
    floorArea: number | null;
    floorAreaUnits: ListingFloorAreaUnits1.T;
};

const roomCount = (label: string, count: number | null): Array<TListingFact> =>
    count === null || count <= 0
        ? []
        : [{ label, value: String(count) }];

export const listingKeyFacts = (props: TListingKeyFactsProps): Array<TListingFact> => [
    // `property_type` is NOT NULL and defaults to 'unknown', so the default has to be
    // treated as absent or every listing claims a type.
    ...(props.propertyType === "unknown"
        ? []
        : [{ label: "Property type", value: ListingPropertyType1.toDisplayName(props.propertyType) }]),
    ...roomCount("Bedrooms", props.bedroomCount),
    ...roomCount("Bathrooms", props.bathroomCount),
    ...roomCount("Living rooms", props.receptionRoomCount),
    ...(props.floorArea === null || props.floorArea <= 0
        ? []
        : [{
            label: "Floor area",
            value: `${Math.round(props.floorArea)} ${ListingFloorAreaUnits1.toSuffix(props.floorAreaUnits)}`,
        }]),
];

export const ListingKeyFacts = (props: TListingKeyFactsProps): JSX.Element | null =>
    <ListingFactPanel heading="Key facts" facts={listingKeyFacts(props)} />;
